<div class="stat-box zoomIn">
    <button class="btn stat-box-btn" (click)="onClick.emit()" [disabled]="!onClick.observers?.length" [rlAria]="counter + ' ' + text" [rlTabIndex]>
        <span class="stat-box-data">{{counter | number:'1.0-2' | forDisplay}}</span>
        <span class="stat-box-title">{{text}}</span>
        <span *ngIf="!hideBar" class="stat-box-bar">
            <span [ngStyle]="{width: ((counter / total) * 100) + '%'}"></span>
        </span>
    </button>
</div>